import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import PageNotFound from './PageNotFound';
import InfoView from './InfoView';
import BookingView from './booking/BookingView';
import RegistrationView from './registration/RegistrationView';
import IntraView from './intra/IntraView';
import RegistryPolicy from './RegistryPolicy';
import TournamentsPage from './TournamentsPage';
import MatchAnalyticsPage from './analytics/MatchAnalyticsPage';
import SecureRoute from './auth/SecureRoute';

const AppRoutes: React.FC = () => (
    <Routes>
        <Route path="/info" element={<InfoView />} />
        <Route path="/registration" element={<RegistrationView />} />
        <Route path="/ilmo" element={<RegistrationView />} />
        <Route path="/booking" element={<BookingView />} />
        <Route
            path="/intra"
            element={
                <SecureRoute>
                    <IntraView />
                </SecureRoute>
            }
        />
        <Route path="/registryPolicy" element={<RegistryPolicy />} />
        <Route path="/tournaments" element={<TournamentsPage />} />
        <Route path="/analytics/:matchId" element={<MatchAnalyticsPage />} />

        <Route path="/" element={<Dashboard />} />
        <Route path="/404" element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
);

export default AppRoutes;
